<template>
  <section className="py-12 bg-blue-50 rounded-xl">
    <div className="container mx-auto px-4">
      <!-- Section header -->
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">{{ title }}</h2>
        <p className="text-gray-600 max-w-2xl mx-auto">{{ subtitle }}</p>
      </div>

      <!-- Testimonials grid -->
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <testimonial-card
            v-for="testimonial in randomTestimonials"
            :key="testimonial.id"
            :testimonial="testimonial"
        />
      </div>
    </div>
  </section>
</template>

<script>
import {computed, ref} from 'vue';
import TestimonialCard from './TestimonialCard.vue';
// Direct import like payment methods
import testimonialsConfig from '../../config/testimonials.json';

export default {
  name: 'TestimonialsSection',
  components: {
    TestimonialCard
  },
  setup() {
    const title = ref(testimonialsConfig.title);
    const subtitle = ref(testimonialsConfig.subtitle);
    const testimonials = ref(testimonialsConfig.testimonials);
// In your setup() function
    const randomTestimonials = computed(() => {
      if (!testimonials.value || testimonials.value.length <= 3) {
        return testimonials.value || [];
      }

      // Clone the array to avoid mutating the original
      const shuffled = [...testimonials.value];

      // Fisher-Yates shuffle (modern version)
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      // Take the first 3
      return shuffled.slice(0, 3);
    });
    return {
      title,
      subtitle,
      testimonials,
      randomTestimonials
    };
  }
}
</script>